export default {
    baseStyle: {
        root: {
            width: '100%',
            textAlign: 'start'
        },
        container: {
            bg: 'white',
            borderColor: 'black.20',
            borderRadius: '2xl',
            borderWidth: '1px'
        },
        button: {
            _expanded: {
                borderBottomRadius: 'none'
            },
            borderRadius: '2xl',
            p: 3
        },
        panel: {
            pb: 3,
            pt: 3,
            px: 3
        }
    },
    defaultProps: {
        variant: 'default'
    }
};

//# sourceMappingURL=accordion.js.map